import { render } from "./SchedulesDetailsContainer.vue?vue&type=template&id=6996ec52&scoped=true"
import script from "./SchedulesDetailsContainer.vue?vue&type=script&lang=js"
export * from "./SchedulesDetailsContainer.vue?vue&type=script&lang=js"

import "./SchedulesDetailsContainer.vue?vue&type=style&index=0&id=6996ec52&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6996ec52"]])

export default __exports__